module.exports = __webpack_public_path__ + "static/profile-84e7fc711b326358ab68d1457c3eb140.png";